import { Drawer, Empty, Modal } from "antd";
import { useEntityFormStore } from "../../stores/entityFormStore";
import { entityFormRegistry } from "./entityFormRegistry";

export function useEntityFormLauncher() {
  return useEntityFormStore((x) => x.openForm);
}

export function EntityFormLauncherHost() {
  const { open, request, closeForm } = useEntityFormStore();
  const def = request ? entityFormRegistry[request.module] : null;
  const Component = def?.component;
  const title = request?.mode === "edit" ? def?.editTitle : def?.createTitle;
  const close = () => {
    request?.onCancel?.();
    closeForm();
  };
  const body = Component && request ? (
    <Component
      mode={request.mode}
      id={request.id}
      initialValues={request.initialValues}
      parentContext={request.parentContext}
      onCancel={close}
      onSaved={(entity) => { request.onSuccess?.(entity); closeForm(); }}
    />
  ) : (
    <Empty description={`No fixed form registered for ${request?.module ?? "module"}`} />
  );

  if (request?.source === "lookup-panel" || def?.presentation === "compact-modal") {
    return (
      <Modal
        title={title}
        open={open}
        onCancel={close}
        footer={null}
        width={request?.module === "party-composite" ? 760 : def?.presentation === "compact-modal" ? 480 : 560}
        zIndex={2200}
        destroyOnClose
        className="entity-form-modal"
      >
        {body}
      </Modal>
    );
  }

  return (
    <Drawer
      title={title}
      width={520}
      open={open}
      onClose={close}
      className="entity-form-drawer"
    >
      {body}
    </Drawer>
  );
}
